export default __webpack_public_path__ + "static/media/BV.6d8f6e66.svg";